import register from '../register.js';
import debounce from './util/debounce.js';

register( 'tooltip', () => {


  function keepOnScreen() {

    const icons = document.querySelectorAll('.tooltip-icon');
    const ttips = document.querySelectorAll('.tooltip-text');

    if ( ttips && icons && ttips.length === icons.length ) {

      for ( let i = 0; i < icons.length; i++ ) {

        const icon = icons[ i ];
        const ttip = ttips[ i ];

        const { x: iconX, width: iconW } = icon.getBoundingClientRect();
        const center = iconX + iconW / 2;

        const ttipWidth = ttip.offsetWidth;

        // If full tooltip fits on screen, center it around the icon
        let margin = -1 * ttipWidth / 2;

        // If we overflow left, glue to left of screen
        if ( center + margin < 0 ) {
          margin = -1 * center;
        }

        // If we overflow right, glue to right of screen
        if ( center + margin + ttipWidth > window.innerWidth ) {
          margin = window.innerWidth - ttipWidth - center;
        }

        ttip.style.marginLeft = margin + 'px';

      }

    }

  }

  window.addEventListener( 'load', keepOnScreen );

  window.addEventListener( 'resize', debounce( keepOnScreen ) );

});

export default undefined;
